import styled from 'styled-components';

export const MainStyled = styled.div`
    grid-area: main;
    padding: 2rem;
    /* ${({ theme }) => theme.mixins.gridRowCenter}; */
`;
